import { useQuery } from '@tanstack/react-query';

import { useMessagingDeps } from '../provider/use-messaging-deps';
import { MessagingChannelConfiguration, MessagingConfigRequest } from '../types/messaging';

// Ported from register's src/queries/messaging/config.ts.
// Only change: `post` (register's hard-wired HTTP helper) -> injected `transport`.
// NOTE: LspId/LocId/UserId are added to the body by each app's transport
// (BaseLocationRequest decoration), not by this query.
export function useMessagingConfigQuery(payload: MessagingConfigRequest, options?: { enabled?: boolean }) {
  const { transport } = useMessagingDeps();

  return useQuery<MessagingChannelConfiguration>({
    queryKey: ['Messaging-Config', payload.Provider, payload.ChannelType, payload.RegisterId],
    queryFn: () => transport<MessagingChannelConfiguration>(`messaging/config/${payload.ChannelType}`, payload),
    enabled: options?.enabled ?? true,
  });
}
